<template>
    <div class="gz-loader" :class="{'spin-cw': loading}"></div>
</template>

<script>
export default {
    name: 'BaseMainLoader',

    props: {
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>